import {
  FrameworkVersionMin,
  FrameworkVersionId,
  FrameworkProfileMin,
  FrameworkModuleTemplates,
  PredefinedControl,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function get(frameworkVersionId: FrameworkVersionId): Promise<FrameworkVersionMin> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/framework_versions/{framework_version_id}",
    {path: {framework_version_id: frameworkVersionId}},
  );
}

export async function listProfiles(frameworkVersionId: FrameworkVersionId): Promise<FrameworkProfileMin[]> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/framework_versions/{framework_version_id}/profiles",
    {path: {framework_version_id: frameworkVersionId}},
  );
}

export async function listControls(frameworkVersionId: FrameworkVersionId): Promise<PredefinedControl[]> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/framework_versions/{framework_version_id}/controls",
    {path: {framework_version_id: frameworkVersionId}},
  );
}

export async function listModuleTemplates(frameworkVersionId: FrameworkVersionId): Promise<FrameworkModuleTemplates> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/framework_versions/{framework_version_id}/module_templates",
    {path: {framework_version_id: frameworkVersionId}},
  );
}

export async function delete_(frameworkVersionId: FrameworkVersionId): Promise<string> {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/framework_versions/{framework_version_id}",
    {path: {framework_version_id: frameworkVersionId}},
  );
  await invalidateQueries([q.tprm.frameworks.filter()]);
  await invalidateQueries([q.tprm.frameworkVersions.filter()]);
  return res;
}

export async function updateVersion(frameworkVersionId: FrameworkVersionId, version: string): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/framework_versions/{framework_version_id}/version",
    {path: {framework_version_id: frameworkVersionId}, body: version},
  );
  await invalidateQueries([q.tprm.frameworks.filter()]);
  await invalidateQueries([q.tprm.frameworkVersions.filter()]);
  return res;
}
